
import './style.css'
export default function Features({ color, Icon1, Icon2, Icon3 }) {
    
  return (
    <>
        <div className="features-container">
        <div className="features-card" style={{ border: `2px solid ${color}`}}>
            <div className="features-icon" style={{ border: `2px solid ${color}`}}>
            {Icon1 && <Icon1 className="features-icon-tag" />}
            </div>
            <h2 style={{color: `${color}`}}>Sprint Relays</h2>
            <p className='black-text-clip'>Test your speed and teamwork in thrilling relay races.</p>
        </div>
        <div className="features-card" style={{ border: `2px solid ${color}`}}>
            <div className="features-icon" style={{ border: `2px solid ${color}`}}>
            {Icon2 && <Icon2 className="features-icon-tag" />}
            </div>
            <h2 style={{color: `${color}`}}>Endurance Challenge</h2>
            <p className='black-text-clip'>Push your limits with fun, competitive distance runs.</p>
        </div>
        <div className="features-card" style={{ border: `2px solid ${color}`}}>
            <div className="features-icon" style={{ border: `2px solid ${color}`}}>
            {Icon3 && <Icon3 className="features-icon-tag" />}
            </div>
            <h2 style={{color: `${color}`}}>Agility Competitions</h2>
            <p className='black-text-clip'>Showcase your quickness and balance in obstacle-based events.</p>
        </div>
    </div>
    </>
  )
}
